// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8479775b","553":"b1862bc3","977":"2f4d16a8"}[chunkId] + ".chunk.js";
};